<template>
	<tr>
		<td class="bigger text">
			<format-date  v-bind:date="uploadDate"></format-date>
		</td>
		<td class="graphite cut-off"><format-user-name v-bind:name="upload.uploadedByName"></format-user-name></td>
		<td class="graphite"><router-link :to="{name: 'CompanyInvestment', params: {investmentId: upload.investmentId}}">{{ upload.investmentName }}</router-link></td>
		<td v-if="canDownload"><a href="#" class="file-name-col" v-on:click.stop v-on:click.prevent="downloadFile" v-bind:data-upload-id="upload.guid" v-bind:data-filename="upload.fileName">{{ upload.fileName }}</a></td>
		<td v-else class="file-name-col graphite">{{ upload.fileName }}</td>

		<td class="graphite">{{ formatStatus(upload.status) }}</td>
		<td class="graphite cut-off"><format-user-name v-bind:name="upload.statusChangedByName" v-if="isApproved"></format-user-name></td>
		<td>
			<div class="btn-group">
				<button v-on:click.stop class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
					Actions
				</button>
				<ul class="dropdown-menu">
					<li v-if="canApprove"><a class="dropdown-item" v-on:click="approveFile">Approve</a></li>
					<li v-if="canReject"><a class="dropdown-item" v-on:click="rejectFile">Reject</a></li>
					<li v-if="canDownload"><a class="dropdown-item" v-on:click.stop v-on:click.prevent="downloadFile" v-bind:data-upload-id="upload.guid" v-bind:data-filename="upload.fileName">Download</a></li>
				</ul>
			</div>
		</td>
	</tr>
</template>

<script type="text/javascript">
	import { useUserStore } from '@/stores/user'
	import { useFundStore } from '@/stores/fund'
	import {formatStatus} from "@/utils/string_utils"
	import FormatDate from '../utils/FormatDate'
	import FileDownload from "@/mixins/FileDownload";
	import FormatUserName from "@/views/utils/FormatUserName";
	import {UploadsApi} from '@/api/uploads_api'
	import {DateTime} from 'luxon'

	export default {
		name: 'DataCollectionUpload',
		props: ['upload'],
		inheritAttrs: false,

		mixins: [FileDownload],

		components: {
			FormatUserName,
			FormatDate
		},

		filters: {
		},

		provide: function() {
			return {
			}
		},

		inject: [],

		data() {
			return {
				companies: []
			}
		},

		computed: {
			isApproved() {
				const curStatus = this.upload.status
				return ['APPROVED', 'COMPLETE', 'ERROR'].find(s => s === curStatus) != null
			},

			canApprove() {
				return this.upload.status == 'PENDING'
			},

			canReject() {
				return this.upload.status == 'PENDING'
			},

			canDownload() {
				return this.upload.status != 'DELETED' && this.upload.status != 'REQUESTED'
			},

			uploadDate() {
				return this.upload ? DateTime.fromISO(this.upload.dateCreated).toJSDate() : null
			}
		},

		watch: {

		},

		setup() {
			const userStore = useUserStore()
			const fundStore = useFundStore()
			return {
				userStore,
				fundStore
			}
		},

		created() {
		},

		mounted() {
		},

		methods: {
			formatStatus,
			approveFile() {
				UploadsApi.updateUploadStatus(this.upload.guid, 'APPROVED')
					.then(resp => {
						console.log('got response to approve', resp)
						this.$emit('uploadApproved', this.upload, resp)
					})
			},
			rejectFile() {
				UploadsApi.updateUploadStatus(this.upload.guid, 'REJECTED')
					.then(resp => {
						this.$emit('uploadRejected', this.upload, resp)
					})
			},
			lookupFundName(companyId) {
				if(companyId) {
					const fund = this.fundStore.funds.find(f => f.companies.indexOf(companyId) > -1)
					return fund ? fund.name : ''
				} else {
					return ''
				}
			},
			lookupCompanyName(companyId) {
				if(companyId) {
					const company = this.companies.find(c => c.id == companyId.toString())
					return company ? company.name : ''
				} else {
					return ''
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import '../../styles/custom-variables.scss';
	.file-name-col {
		line-break: anywhere;
	}
	.graphite {
		color: $graphite;
	}
	.cut-off {
		max-width: 120px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis !important;
	}
</style>
